<template>
  <div style="display: inline-block;clear: bottom;margin-left: 12px">
    <!--  确认框  -->
    <slot></slot>
    <vxe-modal type="confirm"
               status="warning"
               iconStatus="vxe-icon--question"
               v-model="visible"
               :showFooter="true"
               @confirm="$emit('confirm')"
    >
      {{ title }}
    </vxe-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      reference: ''
    }
  },
  props: {
    /**
     * 来自预配置函数
     */
    ready: {
      default: ''
    },
    title: {
      default: '您确定要执行操作吗？'
    },
  },
  mounted() {
    // console.log(this.ready)

    if (this.$slots.default) {
      this.reference = this.$slots.default[0].elm;
    }

    if (this.reference) {
      this.reference.addEventListener('click', this.openVisible, false);
    }

  },
  methods: {
    openVisible() {
      if (typeof this.ready === 'function') {
        if (this.ready()) this.visible = true;
      } else {
        this.visible = true;
      }
    }
  },
}
</script>

<style lang="less">
</style>